export type GeoCoordinates = {
  lat: number;
  lng: number;
};

export type GeocodedLocationValue = {
  address: string;
  coordinates: GeoCoordinates | null;
};

export const emptyGeocodedLocation = (): GeocodedLocationValue => ({
  address: "",
  coordinates: null,
});
